module.exports = __webpack_public_path__ + "01_short_gray.613a4abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_short_gray.png
// module id = TWLp
// module chunks = 0